import { bridge } from '../../../bridge';
import DeviceInfo from '../../../DeviceInfo';
import { getWebBaseURL } from '../../../getWebBaseURL';
import { isIOS } from '../../../isIOS';
import { isNotNil } from '../../../isNotNil';
import { appendParams, finalizeUrl, getDefaultWebviewLink } from '../../utils';

const getPath = (path: keyof typeof WEBVIEW_PAGE | string) => {
  if (isNotNil(WEBVIEW_PAGE[path as keyof typeof WEBVIEW_PAGE])) {
    //정의된 Path라면..?
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return WEBVIEW_PAGE[path];
  }
  return path;
};
export const moveToWebview = async (
  path: keyof typeof WEBVIEW_PAGE | string,
  { titleBar = false }: MoveToWebviewOptions = {},
) => {
  const webviewPath = getPath(path);
  const url = getDefaultWebviewLink(titleBar);

  // const pagePath = WEBVIEW_PAGE[path];
  if ((await DeviceInfo.getVersion()) === '2.334.0' && isIOS) {
    // const changedDeeplink = `ably://webview?title_bar=${titleBar}&url=https://m.a-bly.com${webviewPath}`;
    appendParams(url, 'url', `https://m.a-bly.com${webviewPath}`);
    bridge.openDeeplink(finalizeUrl(url), {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        location.href = `${baseURL}${webviewPath}`;
      },
    });
    return;
  }
  appendParams(url, 'url', `${webviewPath}`);

  bridge.openDeeplink(finalizeUrl(url), {
    webCallback: async () => {
      const baseURL = await getWebBaseURL();
      location.href = `${baseURL}${webviewPath}`;
    },
  });
};

type MoveToWebviewOptions = {
  titleBar?: boolean;
};

const WEBVIEW_PAGE = {
  /** - 장바구니로 이동 */
  Cart: '/cart?from=CARTICON',
  /** - AI 옷입히기 생성 페이지로 이동 */
  CreateOutfitTryOn:
    '/content/fitting-rooms/outfit-try-on/create?conceptId%3D1%26categoryChipKey%3DrecentlyViewed%26entryPoint%3DRECENTLY_VIEWED_GOOD',
  /** - 뷰티관으로 이동  */
  BeautyDepartment: '/screens/?screen_name=BEAUTY_DEPARTMENT',
  /** - 이용약관 */
  TermsOfUse: '/agreement/terms-of-use',
  /** - 개인정보 처리방침 */
  Privacy: '/agreement/privacy',
  /** - 청소년 보호정책 */
  YouthPolicy: '/youth-policy',
} satisfies Record<string, `/${string}`>;
